import { UserStatus } from './UserStatus.enum'

export type DisplayForRule = {
  mode: 'show' | 'hide'
  statuses: UserStatus[]
}

export enum DisplayForValues {
  PROSPECT = 'prospect',
  CLIENT_ACTIVE = 'client_active',
  CLIENT_EXPIRED = 'client_expired',
  CLIENT_ACTIVE_OR_CLIENT_EXPIRED = 'client_active_or_client_expired',
  ALL = 'all'
}
